import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#2F4F4F', // Army green
      light: '#3F5F5F',
      dark: '#1F3F3F',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#000000', // Black
      light: '#333333',
      dark: '#000000',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          minHeight: 48,
          fontSize: '1rem',
          padding: '12px 24px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiDatePicker: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '& .MuiPickersCalendarHeader-root': {
            marginBottom: 2,
            color: '#000000',
          },
          '& .MuiDayCalendar-monthContainer': {
            backgroundColor: '#ffffff',
          },
          '& .MuiPickersDay-root': {
            margin: '2px',
            width: '36px',
            height: '36px',
            color: '#000000',
            '&.Mui-selected': {
              backgroundColor: '#2F4F4F',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#1F3F3F',
              },
            },
            '&.MuiPickersDay-today': {
              border: '2px solid #2F4F4F',
            },
          },
          '& .MuiPickersCalendarHeader-label': {
            fontSize: '1.2rem',
            fontWeight: 500,
            color: '#000000',
          },
          '& .MuiPickersCalendarHeader-switchHeader': {
            color: '#000000',
          },
          '& .MuiPickersArrowSwitcher-button': {
            color: '#000000',
          },
          '& .MuiPickersDay-weekDayLabel': {
            color: '#000000',
            fontWeight: 500,
          },
        },
      },
    },
  },
});

export default theme;